import React from 'react';

import API from '../../../../utils/API';

import InputField from '../../../../components/inputs/inputField';
import ToggleField from '../../../../components/inputs/toggleField';
import FieldModal from '../../../../components/modals/fieldModal';
import SelectField from '../../../../components/inputs/selectField';
class EditPointsModal extends React.Component {
	constructor(props) {
		super(props);
		const point = this.props.markedPoint;
		this.state = {
			customLabel: point.customLabel ? point.customLabel : point.actionName,
			category: point.category ? this.props.categoryOptions.find((c) => c.value === point.category) : '',
			defaultCategoryOptions: [...this.props.categoryOptions],
			filteredCategoryOptions: [...this.props.categoryOptions],
			newCategoryChosen: false,
			description: point.description,
			pointSuffix: point.pointSuffix,
			pointValue: point.pointValue,
			maxPointsAllowed: point.maxPointsAllowed,
			oncePerReference: point.oncePerReference,
			active: point.active,
			callToActionLabel: point.callToActionLabel,
			callToActionUrl: point.callToActionUrl,
			doNotShow: point.doNotShow,
			submitting: false,
			invalid: false,
			success: false,
			callToActionType: point.callToActionType ? point.callToActionType : 'external',
			callToActionInternalType: point.callToActionInternalType ? point.callToActionInternalType : 'page',
			callToActionInternalTypeOptions: [
				{ label: 'Page', value: 'page' },
				{ label: 'Session', value: 'session' }
			],
			callToActionExternalTypeOptions: [
				{ label: 'External', value: 'external' },
				{ label: 'Internal', value: 'internal' }
			],
			pages: this.props.event.appConfiguration.screens.map((s) => {
				return { label: s.name, value: s.id };
			}),
			selectedPage: '',
			referenceModel: point.referenceModel || '',
			applyToAll: !point.applicableObjects?.length,
			applicableObjects: [],
			modelOptions: []
		};
	}

	handleCategoryInputChange = (input) => {
		const newCategory = {
			label: 'New category: ' + input,
			color: '#00B8D9',
			new: true
		};
		const filteredCategories = this.state.defaultCategoryOptions.filter(
			(category) => category.label.toLowerCase().includes(input.toLowerCase())
		);
		this.setState({
			filteredCategoryOptions: [...filteredCategories, newCategory]
		});
	};

	handleCategoryChosen = (selected) => {
		if (selected.new) {
			this.setState({ 
				category: { ...selected, label: selected.label.split('New category: ')[1] },
				newCategoryChosen: true 
			});
		} else {
			this.setState({ 
				category: selected,
				newCategoryChosen: false 
			});
		}
	};

	async componentDidMount() {
		const { markedPoint, orgId, eventId } = this.props;
		const { callToActionType } = this.state;

		// Handle call to action setup
		if (callToActionType === 'internal') {
			if (markedPoint.callToActionInternalType === 'session') {
				let selectedSession = this.props.sessions.find((s) => s._id == markedPoint.callToActionUrl);
				this.setState({
					selectedSession: { label: selectedSession.name, value: selectedSession._id },
					callToActionUrl: selectedSession.name
				});
			} else {
				let selectedPage = this.state.pages.find((p) => p.value == markedPoint.callToActionUrl);
				this.setState({
					selectedPage: { label: selectedPage.label, value: selectedPage.value },
					callToActionUrl: selectedPage.label
				});
			}
		}

		// Handle reference model options
		let modelOptions = [];
		if (markedPoint.referenceModel) {
			let applicableObjects = markedPoint.applicableObjects || [];
			switch (markedPoint.referenceModel) {
				case 'Attendee':
					modelOptions = this.props.attendees.map((a) => ({
						label: a.firstName + ' ' + a.lastName,
						value: a._id
					}));
					applicableObjects = applicableObjects.map((ao) => {
						const a = this.props.attendees.find((a) => a._id == ao);
						return { label: a.firstName + ' ' + a.lastName, value: a._id };
					});
					break;
				case 'Session':
					modelOptions = this.props.sessions.map((s) => ({
						label: s.name,
						value: s._id
					}));
					applicableObjects = applicableObjects.map((ao) => {
						const s = this.props.sessions.find((s) => s._id == ao);
						return { label: s.name, value: s._id };
					});
					break;

				case 'Survey':
					modelOptions = this.props.sessions.filter(s => s.surveyId).map((s) => {
						const surveyId = s.surveyId;
						return {
							label: s.name,
							value: surveyId
						};
					});
					applicableObjects = applicableObjects.map((ao) => {
						const s = this.props.sessions.find((s) => s.surveyId == ao);
						return { label: s.name, value: s.surveyId };
					});
					break;
				case 'Feed':
					modelOptions = this.props.feeds?.map((f) => ({
						label: f.feedName,
						value: f._id
					}));
					applicableObjects = applicableObjects.map((ao) => {
						const f = this.props.feeds.find((f) => f._id == ao);
						return { label: f.feedName, value: f._id };
					});
					break;
				case 'Form':
					const forms = await API().get(`Organizations/${orgId}/events/${eventId}/forms`);
					modelOptions = forms.data.forms.map((f) => ({
						label: f.name,
						value: f._id
					}));
					applicableObjects = applicableObjects.map((ao) => {
						const f = forms.data.forms.find((f) => f._id == ao);
						return { label: f.name, value: f._id };
					});
					break;
				default:
					break;
			}

			this.setState({ modelOptions, applicableObjects });
		}
	}

	submitInteractionPoints = () => {
		const { orgId, eventId, markedPoint } = this.props;
		const {
			selectedPage,
			selectedSession,
			callToActionType,
			callToActionInternalType,
			applicableObjects,
			applyToAll
		} = this.state;

		let callToActionUrl = this.state.callToActionUrl;

		if (callToActionType === 'internal') {
			if (callToActionInternalType === 'page') {
				callToActionUrl = selectedPage.value;
			} else {
				callToActionUrl = selectedSession.value
			}
		}

		const data = {
			customLabel: this.state.customLabel,
			category: this.state.category.new ? this.state.category.label : this.state.category.value,
			description: this.state.description,
			pointSuffix: this.state.pointSuffix,
			pointValue: this.state.pointValue,
			maxPointsAllowed: this.state.maxPointsAllowed,
			oncePerReference: this.state.oncePerReference,
			active: this.state.active,
			callToActionLabel: this.state.callToActionLabel,
			callToActionUrl: callToActionUrl,
			doNotShow: this.state.doNotShow,
			callToActionType: this.state.callToActionType,
			callToActionInternalType: this.state.callToActionInternalType,
			referenceModel: this.state.referenceModel,
			applicableObjects: !applyToAll ? applicableObjects.map(a => a.value) : []
		};

		this.setState({ submitting: true });
		API()
			.patch(`Organizations/${orgId}/events/${eventId}/interactions/point/${markedPoint._id}`, data)
			.then((res) => {
				if (res.data) {
					this.props.editPoint({ ...res.data.interactionPoint, active: this.state.active });
					this.props.toggle();
				}
			})
			.catch((err) => {
				console.log(err);
				this.setState({ submitting: false });
			});
	};

	render() {
		const { isOpen, toggle, sessions, categoryOptions } = this.props;
		const {
			submitting,
			invalid,
			customLabel,
			description,
			pointSuffix,
			pointValue,
			maxPointsAllowed,
			oncePerReference,
			active,
			callToActionLabel,
			callToActionUrl
		} = this.state;

		return (
			<div>
				<FieldModal
					size="medium"
					isOpen={isOpen}
					modalTitle={"Edit Interaction Point"}
					bodyHeaderText={'Points will be earned by attendees as they complete actions'}
					bodyDescription={''}
					overflowHidden={true}
					bodyContent={() => {
						return (
							<div
								style={{
									overflowX: 'hidden',
									height: "calc(100vh - 350px)"
								}}>
								<div>
									<InputField label="Label" value={customLabel}
										onChange={(e) => this.setState({ customLabel: e.target.value })}
									/>
									<InputField
										label="Description"
										value={description}
										onChange={(e) => this.setState({ description: e.target.value })}
									/>

									<SelectField
										label="Category"
										value={this.state.category}
										options={this.state.filteredCategoryOptions}
										onChange={this.handleCategoryChosen}
										onInputChange={this.handleCategoryInputChange}
									/>


									<InputField
										label="Point Value"
										value={pointValue}
										onChange={(e) => this.setState({ pointValue: e.target.value })}
									/>

									<InputField
										label="Submission Limit"
										type="number"
										min="0"
										value={maxPointsAllowed}
										onChange={(e) => this.setState({ maxPointsAllowed: e.target.value })}
									/>

									<ToggleField
										label="Once Per Reference"
										checked={oncePerReference}
										icons={false}
										onChange={() =>
											this.setState({
												oncePerReference: !oncePerReference
											})}
									/>
									{this.state.referenceModel && this.state.referenceModel !== '' && (
										<ToggleField
											label="Apply to all"
											checked={this.state.applyToAll}
											icons={false}
											onChange={() =>
												this.setState({
													applyToAll: !this.state.applyToAll
												})}
										/>
									)}

									{!this.state.applyToAll && this.state.referenceModel && (
										<SelectField
											isMulti={true}
											label={`Select ${this.state.referenceModel}s`}
											value={this.state.applicableObjects}
											options={this.state.modelOptions}
											onChange={(e) =>
												this.setState({
													applicableObjects: e
												})
											}
										/>
									)}

									<InputField label="Call To Action Label" value={callToActionLabel} onChange={(e) => this.setState({ callToActionLabel: e.target.value })} />


									<SelectField
										label="Call To Action Type"
										value={this.state.callToActionExternalTypeOptions.find((o) => o.value === this.state.callToActionType)}
										options={this.state.callToActionExternalTypeOptions}
										onChange={(e) =>
											this.setState({
												callToActionType: e.value,
												callToActionUrl: ''
											})}
									/>

									{this.state.callToActionType === 'internal' && (
										<SelectField
											label="Call To Action Internal Type"
											value={this.state.callToActionInternalTypeOptions.find((o) => o.value === this.state.callToActionInternalType)}
											options={this.state.callToActionInternalTypeOptions}
											onChange={(e) =>
												this.setState({
													callToActionInternalType: e.value,
													callToActionUrl: ''

												})}
										/>
									)}

									{this.state.callToActionType === 'internal' && this.state.callToActionInternalType === 'session' && (
										<SelectField
											label="Session"
											value={this.state.selectedSession}
											options={sessions.map((s) => {
												return { label: s.name, value: s._id };
											})}
											onChange={(e) =>
												this.setState({
													selectedSession: e,
													callToActionUrl: e.label
												})}
										/>
									)
									}

									{this.state.callToActionType === 'internal' && this.state.callToActionInternalType === 'page' && (
										<SelectField
											label="Page"
											value={this.state.selectedPage}
											options={this.state.pages}
											onChange={(e) =>
												this.setState({
													selectedPage: e,
													callToActionUrl: e.label
												})}
										/>
									)
									}

									<InputField
										label="Call To Action Target"
										value={callToActionUrl}
										onChange={(e) => this.setState({ callToActionUrl: e.target.value })}
										disabled={this.state.callToActionType === 'internal'}
									/>

									<ToggleField
										label="Active"
										checked={active}
										icons={false}
										onChange={() =>
											this.setState({
												active: !active
											})}
									/>

									<ToggleField
										label="Do Not Show"
										checked={this.state.doNotShow}
										icons={false}
										onChange={() =>
											this.setState({
												doNotShow: !this.state.doNotShow
											})}
									/>
								</div>
								{invalid && <span style={{ color: 'red' }}>Group name is required</span>}
							</div>)
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Submit' : 'Adding...'}
					actionButton={() => this.submitInteractionPoints()}
					actionButtonDisabled={submitting}
				></FieldModal>





			</div>

		);
	}
}

export default EditPointsModal;
